import { render, staticRenderFns } from "./billDetails.vue?vue&type=template&id=32a213e1&scoped=true&"
import script from "./billDetails.vue?vue&type=script&lang=js&"
export * from "./billDetails.vue?vue&type=script&lang=js&"
import style0 from "./billDetails.vue?vue&type=style&index=0&id=32a213e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a213e1",
  null
  
)

export default component.exports